import { FC, useState, useEffect } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import { useRouter } from 'next/router';
import css from './index.module.scss';
import IconArr from './IconArr';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { locale } = useRouter();
    const { t } = useLang('dp3.teaser.ChargingMethods');
    const [activeIndex, setActiveIndex] = useState<number | null>(0);
    const imgA1 = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718873519756/a1.jpg';
    const imgA2 = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718873538829/a2.jpg';
    const imgA3 = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718873550423/a3.jpg';
    const imgA4 = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718873562581/a4.jpg';
    const imgA5 = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718873575882/a5.jpg';
    const imgA6 = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718873588142/a6.jpg';
    const imgA7 = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718873600226/a7.jpg';
    const imgA8 = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718873613416/a8.jpg';
    const usImg = {
        '1': imgA1,
        '2': imgA2,
        '3': imgA5,
        '4': imgA3,
        '5': imgA4,
        '6': imgA6,
        '7': imgA7,
        '8': imgA8,
    };
    const jpImg = {
        '1': imgA2,
        '2': imgA1,
        '3': imgA3,
        '4': imgA4,
        '5': imgA6,
        '6': imgA7,
        '7': imgA8,
        '8': imgA5,
    };
    const cnImg = {
        '1': imgA2,
        '2': imgA1,
        '3': imgA8,
        '4': imgA4,
        '5': imgA3,
        '6': imgA6,
        '7': imgA7,
        '8': imgA5,
    };
    const aaImg = locale === 'cn' ? cnImg : locale === 'jp' ? jpImg : usImg;
    const [list, setList] = useState([
        {
            title: t('item1_title'),
            desc: t('item1_desc'),
            pc: aaImg['1'],
        },
        {
            title: t('item2_title'),
            desc: t('item2_desc'),
            pc: aaImg['2'],
        },
        {
            title: t('item3_title'),
            desc: t('item3_desc'),
            pc: aaImg['3'],
        },
        {
            title: t('item4_title'),
            desc: t('item4_desc'),
            pc: aaImg['4'],
        },
        {
            title: t('item5_title'),
            desc: t('item5_desc'),
            pc: aaImg['5'],
        },
        {
            title: t('item6_title'),
            desc: t('item6_desc'),
            pc: aaImg['6'],
        },
        {
            title: t('item7_title'),
            desc: t('item7_desc'),
            pc: aaImg['7'],
        },
        {
            title: t('item8_title'),
            desc: t('item8_desc'),
            pc: aaImg['8'],
        },
    ]);

    useEffect(() => {
        if (locale === 'au') {
            setList([
                {
                    title: t('item1_title'),
                    desc: t('item1_desc'),
                    pc: aaImg['1'],
                },
                {
                    title: t('item2_title'),
                    desc: t('item2_desc'),
                    pc: aaImg['2'],
                },
                {
                    title: t('item4_title'),
                    desc: t('item4_desc'),
                    pc: aaImg['4'],
                },
                {
                    title: t('item5_title'),
                    desc: t('item5_desc'),
                    pc: aaImg['5'],
                },
                {
                    title: t('item6_title'),
                    desc: t('item6_desc'),
                    pc: aaImg['6'],
                },
                {
                    title: t('item7_title'),
                    desc: t('item7_desc'),
                    pc: aaImg['7'],
                },
                {
                    title: t('item8_title'),
                    desc: t('item8_desc'),
                    pc: aaImg['8'],
                },
            ]);
        }
    }, []);

    // 鼠标移入
    const mouseEnterHandle = (index: number) => {
        setActiveIndex(index);
    };

    return (
        <div id="dp3-teaser-I" className={`${css.thecomp} dp3-module-box dp3-teaser-I`}>
            <div className="dp3-inter">
                <div className="ChargingMethods-l">
                    <h2 className="dp3-title left">{t('title')}</h2>
                    {list.map((item: any, index: number) => {
                        if (!item.title || !item.desc) {
                            return null;
                        }
                        return (
                            <div
                                key={index}
                                className={`ChargingMethods-item${activeIndex === index ? ' ChargingMethods-item-active' : ''}`}
                                onClick={() => {
                                    mouseEnterHandle(index);
                                }}
                            >
                                <div className="ChargingMethods-item-title">
                                    {item.title}
                                    <IconArr />
                                </div>
                                <div className="ChargingMethods-item-desc">{item.desc}</div>
                                <div className="ChargingMethods-item-img">
                                    <EditorImg pc={item.pc} />
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="ChargingMethods-r"></div>
            </div>
        </div>
    );
};

export default TheComp;
